<template>
<div>
    <div class="login-container">
        <div class="login-header">
             <div>{{appName}}</div>
        </div>
        <div class="login-body">
            <div class="login-info">
                <div  style="margin-top:20px;font-size:20px;">欢迎登录{{appName}}</div>

                <div style="display:flex;justify-content:center;">
                    <div style="margin-top:50px;">
                        <el-tabs v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane label="手机号密码登录" name="PWD">
                                <el-form ref="form" :model="form"  >
                                    <el-form-item  class="form-item">
                                        <el-input type="text" v-model="form.userPhone" placeholder="请输入手机号"></el-input>
                                    </el-form-item>
                                    <el-form-item class="form-item">
                                        <el-input  v-model="form.password" type="password" placeholder="请输入密码"></el-input>
                                    </el-form-item>
                                </el-form>
                            </el-tab-pane>
                            <el-tab-pane label="手机号验证码登录" name="CC">
                                <el-form ref="form" :model="form"  >
                                    <el-form-item  class="form-item">
                                        <el-input type="text" v-model="form.userPhone" placeholder="请输入手机号"></el-input>
                                    </el-form-item>
                                    <el-form-item class="form-item">
                                        <el-input placeholder="请输入验证码" v-model="form.checkCode">
                                            <template slot="append">
                                                <el-button slot="append" @click="getCheckCode" >发送验证码</el-button>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </el-form>    
                            </el-tab-pane> 
                        </el-tabs>
                         <el-button type="primary" @click="onSubmit" class="form-item" style="width:250px;">登录</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="login-footer">
            Copyright © 2020 南京友穗商业服务有限公司版权所有  
        </div>
        <!-- <div>
            <el-row v-for="(item,index) in list" :key="index" v-if="index%2==0">
                <el-col :span="12">
                    {{testForComputer(index)}}
                </el-col>
                <el-col :span="12">
                    {{testForComputer(index+1)}}
                </el-col>
            </el-row>
        </div> -->
    </div>

</div>
</template>
<script>
import common from '../../public/static/common';
import  asyncApi   from '../api/asyncApi'
export default {
    name: 'Login',
    data() {
        return {
            appName:common.appName,
            activeName:"PWD",
            form: {
                userPhone: '',
                password: '',
                checkCode:'',
                sysCode:'PC',
                loginType:'PWD',
            },
            list:[{"k":"xxx0",v:"vvv-"},{"k":"xxx1",v:"vvv1"},{"k":"xxx2",v:"vvv2"},{"k":"xxx3",v:"vvv3"},{"k":"xxx4",v:"vvv4"}]
        }
    },
    async created(){
        // //console.log("顺序 0")
        // await this.testAsync();
        // //console.log("顺序 3")
    },
    methods: {
        // async testAsync(){
        //     //console.log("顺序 1")
        //     let url ="/extwarapi/api/dicProdBrand/getBrandEnum";
        //     let t = await asyncApi.post(url,null);           
        //     //console.log(t)
        //     //console.log("顺序 2")
        // },
       testForComputer(index){
           return this.list[index];
       },
        onSubmit() {
            let url="/extwarapi/loadAuth";
            let param = this.form;
            this.axios.post(url, param).then((resp) => {
                if(resp.data.code!='0000')  { 
                    this.$alert(resp.data.msg, '提示信息', {
                        confirmButtonText: '确定',
                        callback: action => {                            
                    }
                    });
                }else{
                    //登录成功,将token存储到本地会话里
                    let token = resp.data.result.token
                    //注意logout时，将token清空
                    sessionStorage.setItem("token", token); 
                    
                    let userInfo = resp.data.result.userInfo;
                    let userRoleList = resp.data.result.userRoleList;
                    let suser = JSON.stringify(userInfo);
                    let suserRoleList = JSON.stringify(userRoleList)
                    //console.log("suser",suser,'list',suserRoleList);
                    window.sessionStorage.setItem("suser", suser);
                    window.sessionStorage.setItem("suserRoleList",suserRoleList) 
                    this.$router.push({name: 'index'})
                }
                 //console.log("resp",resp);
                              
            }).catch((resp) => {
                //console.log('error', resp); 
            })
            
        },
        handleClick(tab, event) {
            // //console.log(tab, event);
            this.form.loginType = tab.name;
        },
        getCheckCode(){
            let url = "/extwarapi/getCheckCode"
            let param = this.form;
            this.axios.post(url, param).then((resp) => {

                this.$alert(resp.data.msg, '提示信息', {
                        confirmButtonText: '确定',
                        callback: action => {                            
                    }
                });
                  
                //console.log("resp",resp);
                              
            }).catch((resp) => {
                //console.log('error', resp); 
            })
        },    
  
    },
}


</script>
<style lang="scss" scoped>
.el-input__inner{
    width: 200px;
    border: none;
    border-bottom: 1px solid #e9e9e9;
    padding: 16px 50px;
} 
.login-header {
  display: flex;  
  height: 100px;
  flex: 1;
  font-size: 40px;
  justify-content:flex-start;

  align-items: center ;
  padding-left:50px;
}
.login-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  border:0px red solid;
  min-height: 100vh;
}
.login-body {
  display: flex;
  flex: 5 ;
  background-color: white;
  height:100%;
  background-image: url(../assets/login-bg.png);
  background-size: 100% 100%;
  justify-content:  flex-end;
  align-items:center;
}
.login-info{
    border-radius: 10px;
    height:450px;
    width:400px;
    background-color:white;
    margin-right:250px;
}
.login-footer {
  height: 100px;
  flex: 1;
  display: flex;
  justify-content:center;
  align-items:center
}

.form-item{
    margin-top:30px;
}


</style>